import { Download, Briefcase, GraduationCap, FileText } from 'lucide-react';


const CV_FILE = '/MAHJOUBI-Mohammed.pdf';

const experiences = [
    {
        period: '2022 — Présent',
        title: 'Production Support monétique',
        company: 'IPRC an HPS',
        points: [
            'Supervision des applications, serveurs et interfaces monétiques',
            "Analyse et résolution d'incidents (niveaux 1 & 2), identification des causes racines",
            'Planification et supervision des traitements batch',
            "Gestion des tickets d’incidents et coordination avec les équipes techniques",
        ],
    },
    {
        period: '2023 — 2024',
        title: 'Projet de fin d\'études',
        company: 'Plateforme de gestion scolaire',
        points: [
            'Application web full-stack (Spring Boot, Spring Security, ReactJS)',
            "Authentification sécurisée, gestion des rôles et CRUD complet",
            'Communication frontend / backend via API REST',
            'Réalisation d’un CRUD complet pour la gestion des données.',
            
        ],
    },
];

const education = [
    { period: '2024 — 2025', title: 'Master Ingénierie de Conception et de Développement d\'Applications', school: 'ENSI' },
    { period: '2019 — 2021', title: 'Master Mécanique énergétique', school: 'Université Hassan II Casablanca' },
    { period: '2016 — 2019', title: 'Licence sciences de la matière physique', school: 'Université Hassan II Casablanca' },
];

function CV() {
    return (
        <>
            <style>{css}</style>
            <section className="cv-page">
                <div className="cv-hero">
                    <span className="eyebrow">Curriculum Vitae</span>
                    <h1>Mahjoubi Mohammed</h1>
                    <p>
                        Ingénieur software — 4 ans d'expérience en support production
                        monétique et développement web sur environnements bancaires
                        critiques.
                    </p>

                    <div className="cv-actions">
                        <a href={CV_FILE} download className="btn-primary">
                            <Download size={18} /> Télécharger le CV (PDF)
                        </a>
                        <a href={CV_FILE} target="_blank" rel="noopener noreferrer" className="btn-secondary">
                            <FileText size={18} /> Voir en ligne
                        </a>
                    </div>
                </div>

                <div className="cv-body">
                    <div className="cv-col">
                        <h2><Briefcase size={18} /> Expérience</h2>
                        <div className="timeline">
                            {experiences.map((exp) => (
                                <div key={exp.title} className="timeline-item">
                                    <span className="timeline-period">{exp.period}</span>
                                    <h3>{exp.title}</h3>
                                    <span className="timeline-company">{exp.company}</span>
                                    <ul>
                                        {exp.points.map((point) => (
                                            <li key={point}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="cv-col">
                        <h2><GraduationCap size={18} /> Formation</h2>
                        <div className="timeline">
                            {education.map((edu) => (
                                <div key={edu.title} className="timeline-item">
                                    <span className="timeline-period">{edu.period}</span>
                                    <h3>{edu.title}</h3>
                                    <span className="timeline-company">{edu.school}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="cv-footer-cta">
                    <p>Le PDF contient le détail complet des compétences et outils.</p>
                    <a href={CV_FILE} download className="btn-primary">
                        <Download size={18} /> Télécharger le CV
                    </a>
                </div>
            </section>
        </>
    );
}

export default CV;

const css = `
.cv-page {
  --bg: #0A0E14;
  --panel: #10151F;
  --border: #1E2530;
  --text: #E7ECF3;
  --muted: #8B96A5;
  --green: #22D3A5;

  background: var(--bg);
  color: var(--text);
  font-family: 'IBM Plex Sans', sans-serif;
  padding: 72px 32px 96px;
}

.cv-hero {
  max-width: 640px;
  margin: 0 auto 64px;
  text-align: center;
}
.eyebrow {
  display: block;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 12px;
  letter-spacing: 0.08em;
  color: var(--green);
  margin-bottom: 14px;
}
.cv-hero h1 {
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(28px, 4vw, 38px);
  margin: 0 0 14px;
}
.cv-hero p { color: var(--muted); line-height: 1.7; margin-bottom: 32px; }

.cv-actions { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }
.btn-primary, .btn-secondary {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 13px 22px;
  border-radius: 6px;
  font-size: 14px; font-weight: 600;
  cursor: pointer; border: 1px solid transparent;
  text-decoration: none;
  transition: transform .15s ease, border-color .15s ease, color .15s ease;
  font-family: inherit;
}
.btn-primary { background: var(--green); color: #04140F; }
.btn-primary:hover { transform: translateY(-1px); }
.btn-secondary { background: transparent; color: var(--text); border-color: var(--border); }
.btn-secondary:hover { border-color: var(--green); color: var(--green); }

.cv-body {
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 40px;
}

.cv-col h2 {
  display: flex; align-items: center; gap: 8px;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  color: var(--green);
  margin: 0 0 24px;
}

.timeline { display: flex; flex-direction: column; gap: 24px; }
.timeline-item {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 18px 20px;
}
.timeline-period {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 11px;
  color: var(--muted);
  letter-spacing: 0.04em;
}
.timeline-item h3 { font-size: 15px; margin: 8px 0 2px; }
.timeline-company { font-size: 12.5px; color: var(--muted); }
.timeline-item ul { margin: 12px 0 0; padding-left: 18px; }
.timeline-item li { font-size: 13px; color: var(--muted); line-height: 1.7; }

.cv-footer-cta {
  max-width: 640px;
  margin: 72px auto 0;
  text-align: center;
  padding-top: 40px;
  border-top: 1px solid var(--border);
}
.cv-footer-cta p { color: var(--muted); margin-bottom: 20px; font-size: 14px; }

@media (max-width: 800px) {
  .cv-body { grid-template-columns: 1fr; }
}
`;